import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { renderRichText } from "gatsby-source-contentful/rich-text"
import { BLOCKS } from "@contentful/rich-text-types"

const options = {
  renderNode: {
    [BLOCKS.EMBEDDED_ASSET]: node => {
      let { localFile, description } = node.data.target
      return <GatsbyImage image={getImage(localFile)} alt={description} style={{ marginBottom: '2em' }}/>
    }
  }
}

const RichText = ({ content }) => <div>{renderRichText(content, options)}</div>

export default RichText